import { render } from "./SupplierView.vue?vue&type=template&id=4ef226aa&scoped=true"
import script from "./SupplierView.vue?vue&type=script&lang=js"
export * from "./SupplierView.vue?vue&type=script&lang=js"

import "./SupplierView.vue?vue&type=style&index=0&id=4ef226aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef226aa"]])

export default __exports__